import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { useEffect } from 'react';

import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ScrollToTop from './ScrollToTop';

import { AuthProvider } from '../context/AuthContext';
import { ProtectedRouteAdmin, ProtectedRouteAuthor } from './ProtectedRoute';

import NotFound from '../pages/NotFound';
import Home from '../pages/Home';
import Events from '../pages/Events';
import Poems from '../pages/Poems';
import EventDatails from '../pages/EventDatails';
import Tourism from '../pages/Tourism';
import TourismDatails from '../pages/TourismDatails';
import Login from '../pages/Login';
import Panel from '../pages/Panel';
import NewEvent from '../pages/NewEvent';
import History from '../pages/History';
import FormAuthors from '../pages/FormAuthors';
import Authors from '../pages/Authors';
import FormBooks from '../pages/FormBooks';
import AuthorPanel from '../pages/AuthorPanel';
import AuthorDatails from '../pages/AuthorDatails';
import BooksDetails from '../pages/BooksDatails';
import AllAuthorsAndBooks from '../pages/AllAuthors';
import FormAuthorComplete from '../pages/FormAuthorComplete';
import FormArtist from '../pages/FormArtist';
import ArtistList from '../pages/ArtistList';
import ArtistDetails from '../pages/ArtistDetails';
import Map from '../pages/Map';
import FormPoems from '../pages/FormPoems';

function AppRoutes() {
  const location = useLocation();

  const hideNavbarRoutes = [
    '/login',
    '/autores/login',
    '/painel-administrativo',
    '/criar-evento',
    '/autores/painel',
    '/autores/painel/completar-perfil',
    '/autores/painel/cadastro-de-livros'
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
    <AuthProvider>
      {!hideNavbarRoutes.includes(location.pathname) && <Navbar />}
      <main>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/eventos' element={<Events />} />
          <Route path='/poesias' element={<Poems />} />
          <Route path='/evento/:url' element={<EventDatails />} />
          <Route path='/pontos-turisticos' element={<Tourism />} />
          <Route path='/ponto-turistico/:url' element={<TourismDatails />} />
          <Route path='/historia' element={<History />} />
          <Route path='/mapa-cultural' element={<FormArtist />} />
          <Route path="/mapa" element={<Map />} />
          <Route path="/concurso-de-poesia" element={<FormPoems />} />
          <Route path='/artistas' element={<ProtectedRouteAdmin><ArtistList /></ProtectedRouteAdmin>} />
          <Route path='/artista/:id' element={<ProtectedRouteAdmin><ArtistDetails /></ProtectedRouteAdmin>} />
          <Route path='/login' element={<Login type='admin' />} />
          <Route path='/painel-administrativo' element={<ProtectedRouteAdmin><Panel /></ProtectedRouteAdmin>} />
          <Route path='/criar-evento' element={<ProtectedRouteAdmin><NewEvent /></ProtectedRouteAdmin>} />
          <Route path='/autores' element={<Authors />} />
          <Route path='/autores/todos' element={<AllAuthorsAndBooks type='authors' />} />
          <Route path='/autores/livros' element={<AllAuthorsAndBooks type='books' />} />
          <Route path='/autores/:id' element={<AuthorDatails />} />
          <Route path='/autores/livros/:id' element={<BooksDetails />} />
          <Route path='/autores/login' element={<Login type='author' />} />
          <Route path='/autores/painel' element={<ProtectedRouteAuthor><AuthorPanel /></ProtectedRouteAuthor>} />
          <Route path='/autores/cadastro-de-autores' element={<FormAuthors />} />
          <Route path='/autores/painel/completar-perfil' element={<ProtectedRouteAuthor><FormAuthorComplete /></ProtectedRouteAuthor>} />
          <Route path='/autores/painel/cadastro-de-livros' element={<ProtectedRouteAuthor><FormBooks /></ProtectedRouteAuthor>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!hideNavbarRoutes.includes(location.pathname) && <Footer />}
    </AuthProvider>
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppRoutes />
    </BrowserRouter>
  );
}
